/* SUNVOLT – Nyligen visade produkter.
   Två delar (samma fil, laddas globalt via theme.liquid):
   1) SPARA: på produktsidor (URL /products/{handle}) sparas handle i localStorage (dedupe, cap).
   2) RENDERA: om "Sunvolt: Nyligen visade"-sektionen finns på sidan → hämta varje korts-HTML via
      /products/{handle}?view=card (templates/product.card.liquid, layout none) och injicera i griden,
      i sparad ordning, exklusive nuvarande produkt. Sektionen är hidden tills minst ett kort lagts in. */
(function () {
  var KEY = 'sv-recently-viewed';
  var MAX = 12;

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  // 1) Spara nuvarande produkt
  var cur = currentHandle();
  if (cur) {
    try {
      var arr = read().filter(function (h) { return h !== cur; });
      arr.unshift(cur);
      localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
    } catch (e) {}
  }

  // 2) Rendera sektionen (om den finns)
  function render() {
    var sec = document.querySelector('[data-sv-recently-viewed]');
    if (!sec) return;
    var grid = sec.querySelector('[data-sv-rv-grid]');
    if (!grid) return;

    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
    var handles = read().filter(function (h) { return h && h !== cur; }).slice(0, limit);
    if (!handles.length) return; // sektionen förblir dold

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      htmls.forEach(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var card = tmp.querySelector('.card-wrapper') || tmp.firstElementChild;
        if (!card) return;
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.appendChild(card);
        grid.appendChild(li);
      });
      if (grid.children.length) sec.removeAttribute('hidden');
    });
  }

  if (document.readyState !== 'loading') render();
  else document.addEventListener('DOMContentLoaded', render);
})();
